import { api, extractResponseData } from "./base";

export const search = async ({ term, pageNumber, pageSize, statuses, types }) => {
  try {
    const response = await api.post("/platform/practice-collections/search", {
      term,
      pageNumber,
      pageSize,
      statuses,
      types,
    });

    if (!response?.data) {
      throw new Error("Invalid response structure");
    }

    const responseData = extractResponseData(response);
    return responseData;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "Unknown error";
    console.error(`Error searching practice collections: ${errorMessage}`);
    throw new Error(`Failed to search practice collections: ${errorMessage}`);
  }
};

export const get = async (id) => {
  try {
    const response = await api.get(`/platform/practice-collections/${id}`);
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error fetching practice collection with ID ${id}:`, error);
    throw new Error(
      `Failed to fetch practice collection with ID ${id}: ${error.message}`,
    );
  }
};

export const getWithCovers = async (id) => {
  try {
    const response = await api.get(
      `/platform/practice-collections/${id}/with-covers`,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(
      `Error fetching practice collection with covers for ID ${id}:`,
      error,
    );
    throw new Error(
      `Failed to fetch practice collection with covers for ID ${id}: ${error.message}`,
    );
  }
};

export const create = async (data) => {
  try {
    const response = await api.post("/platform/practice-collections", data);
    return extractResponseData(response);
  } catch (error) {
    console.error("Error creating practice collection:", error);
    throw new Error(`Create failed: ${error.message}`);
  }
};

export const update = async (id, data) => {
  try {
    const response = await api.put(
      `/platform/practice-collections/${id}`,
      data,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error updating practice collection with ID ${id}:`, error);
    throw new Error(`Update failed: ${error.message}`);
  }
};

export const publish = async (id) => {
  try {
    const response = await api.post(
      `/platform/practice-collections/${id}/publish`,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error publishing practice collection with ID ${id}:`, error);
    throw new Error(
      `Failed to publish practice collection with ID ${id}: ${error.message}`,
    );
  }
};

export const approve = async (id) => {
  try {
    const response = await api.post(
      `/platform/practice-collections/${id}/approve`,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error approving practice collection with ID ${id}:`, error);
    throw new Error(
      `Failed to approve practice collection with ID ${id}: ${error.message}`,
    );
  }
};

export const release = async (id) => {
  try {
    const response = await api.post(
      `/platform/practice-collections/${id}/release`,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error releasing practice collection with ID ${id}:`, error);
    throw new Error(
      `Failed to release practice collection with ID ${id}: ${error.message}`,
    );
  }
};

export const archive = async (id) => {
  try {
    const response = await api.post(
      `/platform/practice-collections/${id}/archive`,
    );
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error archiving practice collection with ID ${id}:`, error);
    throw new Error(
      `Failed to archive practice collection with ID ${id}: ${error.message}`,
    );
  }
};

export const createPathway = async (data) => {
  try {
    const response = await api.post("/platform/practice-pathways", data);
    return extractResponseData(response);
  } catch (error) {
    console.error("Error creating practice pathway:", error);
    throw new Error(`Create pathway failed: ${error.message}`);
  }
};

export const getPathway = async (id) => {
  try {
    const response = await api.get(`/platform/practice-pathways/${id}`);
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error fetching practice pathway with ID ${id}:`, error);
    throw new Error(
      `Failed to fetch practice pathway with ID ${id}: ${error.message}`,
    );
  }
};

export const searchPathways = async ({ term, pageNumber, pageSize }) => {
  try {
    const response = await api.post("/platform/practice-pathways/search", {
      term,
      pageNumber,
      pageSize,
    });
    return extractResponseData(response);
  } catch (error) {
    console.error("Error searching practice pathways:", error);
    throw new Error(`Failed to search pathways: ${error.message}`);
  }
};

export const updatePathway = async (id, data) => {
  try {
    const response = await api.put(`/platform/practice-pathways/${id}`, data);
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error updating practice pathway with ID ${id}:`, error);
    throw new Error(`Update pathway failed: ${error.message}`);
  }
};

export const deleteCollection = async (id) => {
  try {
    const response = await api.delete(`/platform/practice-collections/${id}`);
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error deleting practice collection with ID ${id}:`, error);
    throw new Error(`Delete failed: ${error.message}`);
  }
};

export const deletePathway = async (id) => {
  try {
    const response = await api.delete(`/platform/practice-pathways/${id}`);
    return extractResponseData(response);
  } catch (error) {
    console.error(`Error deleting practice pathway with ID ${id}:`, error);
    throw new Error(`Delete pathway failed: ${error.message}`);
  }
};
